import { useMutationState } from '@tanstack/react-query';
import { slide as Menu } from 'react-burger-menu';
import Skeleton from 'react-loading-skeleton';

import { useLogOut } from '@/api';
import { SignUpIcon } from '@/components/icons/header';
import { CustomBurgerIcon, CustomCloseIcon } from '@/components/icons/header/menu';
import { Button } from '@/components/shared/Button';
import { useAuthStore, useModalStore } from '@/store';

import { menuItemsList, newsList } from './constants.tsx';
import { MenuItemsList } from './MenuItemList/MenuItemsList.tsx';
import cn from './styles.module.scss';

export const BurgerMenu = ({ onClick }: { onClick: (signingUp: boolean) => void }) => {
    const { isAuth } = useAuthStore();
    const { isBurgerMenuOpen, setIsBurgerMenuOpen } = useModalStore();
    const { mutate: logOut, isPending: isLogOutPending } = useLogOut();
    const signInStatus = useMutationState({
        filters: { mutationKey: ['sign-in'] },
        select: mutation => mutation.state.status,
    });

    const isSignInPending = signInStatus.at(-1) === 'pending';

    const handleOpen = () => {
        setIsBurgerMenuOpen(true);
    };

    const handleClose = () => {
        setIsBurgerMenuOpen(false);
    };

    const handleLogOut = () => {
        logOut();
    };

    const handleOpenSignUp = () => {
        onClick(true);
    };

    const handleOpenSighIn = () => {
        onClick(false);
    };

    const LogOutBtn = isLogOutPending ? (
        <Skeleton height={38} borderRadius={8} />
    ) : (
        <Button onClick={handleLogOut} background="transparent" className={cn.btnLogOut}>
            <span>{SignUpIcon}</span>
            <span>Выйти из профиля</span>
        </Button>
    );

    const AuthBtns = isSignInPending ? (
        <Skeleton
            height={51}
            count={2}
            borderRadius={10}
            containerClassName={cn.authBtnsSkeletonContainer}
        />
    ) : (
        <>
            <button onClick={handleOpenSignUp} className={cn.btnSignUp}>
                Зарегистрироваться
            </button>
            <button onClick={handleOpenSighIn} className={cn.btnSignIn}>
                Войти
            </button>
        </>
    );

    return (
        <div className={cn.bmContainer}>
            <Menu
                customBurgerIcon={CustomBurgerIcon}
                customCrossIcon={CustomCloseIcon}
                width={350}
                isOpen={isBurgerMenuOpen}
                onOpen={handleOpen}
                onClose={handleClose}
                right
            >
                <img
                    className={cn.logo}
                    src="/images/icons/logo_dark.svg"
                    width={108}
                    height={40}
                    alt=""
                />

                <MenuItemsList onClick={handleClose} itemsList={menuItemsList} title="Меню" />

                <div className={cn.divider} />

                <MenuItemsList itemsList={newsList} title="Новости" direction="row" />

                <div className={cn.menuButtons}>{isAuth ? LogOutBtn : AuthBtns}</div>
            </Menu>
        </div>
    );
};
